import React from 'react'
import classnames from 'classnames'
import styled from 'styled-components/macro'

type Props = {
  className?: string
}

const OrdersTableHeader = ({className}: Props) => {
  return (
    <OrdersTableHeader.Styled className={classnames('orders-table-header', className)}>
      <h3>All Properties</h3>
    </OrdersTableHeader.Styled>
  )
}

OrdersTableHeader.Styled = styled.div``

export default OrdersTableHeader
